import { filters as fabricFilters } from 'fabric';
import { T2DPipelineState, TMatColorMatrix } from 'fabric/src/filters/typedefs';

import { Options } from './types';

class TrueBlackAndWhite extends fabricFilters.ColorMatrix<'TrueBlackAndWhite'> {
  static override type = 'TrueBlackAndWhite';

  declare value: number;

  calculateMatrix() {
    const coloMatrix = [0.2, 0.4, 0.4, 0, 0, 0.2, 0.4, 0.4, 0, 0, 0.2, 0.4, 0.4, 0, 0, 0, 0, 0, 1, 0];

    const baseMatrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

    const nVal = this.value / 100;

    this.matrix = coloMatrix.map((element, i) => element * nVal + baseMatrix[i] * (1 - nVal)) as TMatColorMatrix;
  }

  override isNeutralState(options: Options) {
    this.calculateMatrix();
    return fabricFilters.BaseFilter.prototype.isNeutralState.call(this, options);
  }

  override applyTo(options: T2DPipelineState) {
    this.calculateMatrix();
    fabricFilters.BaseFilter.prototype.applyTo.call(this, options);
  }

  override toObject() {
    return {
      ...super.toObject(),
      value: this.value,
    };
  }
}

export default TrueBlackAndWhite;
